module.exports = __webpack_public_path__ + "media/icon_transaction/hedgehog_3-87072b14.png";